// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"803":"1a6b2fd2","835":"783215e8"}[chunkId] + ".chunk.js";
};